import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const meetingsRoutes: RouteObject = {
  path: ROUTES.meetings.root,
  children: [
    {
      index: true,
      lazy: async () => {
        const { MeetingPage } =
          await import('../../../pages/meetings/Meeting.page');

        return { Component: MeetingPage };
      },
    },
    {
      path: ROUTES.meetings.slots,
      lazy: async () => {
        const { MeetingFormPage } =
          await import('../../../pages/meetings/MeetingForm.page');

        return { Component: MeetingFormPage };
      },
    },
    {
      path: ROUTES.meetings.print,
      lazy: async () => {
        const { MeetingPrintPage } =
          await import('../../../pages/meetings/MeetingPrint.page');

        return { Component: MeetingPrintPage };
      },
    },
  ],
};
